import React from 'react';
import MDCTextField from './MDCTextField.js.jsx';
import TenantFormFirstNameField from './TenantFormFirstNameField.js.jsx';
import classNames from 'classnames';
import tenantFormStyles from '../../../stylesheets/management_site/tenantForm.module.scss';
import newLeaseModalStyles from '../../../stylesheets/management_site/newLeaseModal.module.scss';

const TenantFormNameFields = ({
  tenantIndex,
  tenantDisplayNumber,
  tenantTermOverride,
  tenantRoles,
  primaryTenantRole,
  unit,
  searchResults,
  isSearching,
  showAutocomplete,
  onSearchEntities,
  onSelectTenant,
  onHideAutocomplete,
  showClearButton,
  onClearEntitySearch,
  licenseData,
}) => {
  return (
    <div className={newLeaseModalStyles.newLeaseModalSection}>
      <div className={newLeaseModalStyles.sectionHeader}>
        <h3 className={newLeaseModalStyles.sectionTitle}>
          Personal Information
        </h3>
      </div>
      <div className={newLeaseModalStyles.sectionContent}>
        <div
          className={classNames('pm-flex', tenantFormStyles.personalInfoRow)}
        >
          <div className={tenantFormStyles.expandableNameFields}>
            <div className="pm-flex pm-flex-3">
              <TenantFormFirstNameField
                label="First Name"
                name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_attributes][firstname]`}
                id={`lease_tenant_lease_relationships_attributes_${tenantIndex}_tenant_attributes_firstname`}
                enableAutocomplete={true}
                searchResults={searchResults}
                isSearching={isSearching}
                showAutocomplete={showAutocomplete}
                onInputChange={(e) => onSearchEntities(e.target.value)}
                onSelectTenant={onSelectTenant}
                onHideAutocomplete={onHideAutocomplete}
              />
              <MDCTextField
                label="Middle Name"
                name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_attributes][mi]`}
                id={`lease_tenant_lease_relationships_attributes_${tenantIndex}_tenant_attributes_mi`}
              />
              <MDCTextField
                label="Last Name"
                name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_attributes][lastname]`}
                id={`lease_tenant_lease_relationships_attributes_${tenantIndex}_tenant_attributes_lastname`}
              />
              {unit.property_type?.tenants_have_company_name && (
                <MDCTextField
                  label="Company Name"
                  name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_attributes][company_name]`}
                  id={`lease_tenant_lease_relationships_attributes_${tenantIndex}_tenant_attributes_company_name`}
                />
              )}
            </div>
          </div>

          {tenantIndex > 0 ? (
            <div className="pm-flex pm-flex-col">
              <div className="pm-select">
                <label className="tenant_type_label">
                  {tenantTermOverride} type
                </label>
                <select
                  name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_role_id]`}
                  className="pm-default-select2-menu mdc-select pm-select-small"
                  defaultValue={tenantRoles?.[0]?.[1] || ''}
                >
                  {tenantRoles?.map((role) => (
                    <option key={role[1]} value={role[1]}>
                      {role[0]}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ) : (
            <input
              type="hidden"
              name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_role_id]`}
              value={primaryTenantRole}
            />
          )}

          <div
            className={classNames(
              'pm-flex',
              'pm-flex-col',
              'field',
              'tenant-license-role',
              tenantFormStyles.tenantDropdown
            )}
          >
            <div className="pm-select">
              <label
                htmlFor={`lease_tenant_lease_relationships_attributes_${tenantIndex}_license_role_tenant_lease_relationship_attributes_license_role_id`}
              >
                {tenantTermOverride} Role
              </label>
              <select
                name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][license_role_tenant_lease_relationship_attributes][license_role_id]`}
                id={`lease_tenant_lease_relationships_attributes_${tenantIndex}_license_role_tenant_lease_relationship_attributes_license_role_id`}
                className="pm-default-select2-menu mdc-select pm-select-small"
                defaultValue={licenseData?.licenseRoles?.[0]?.[1] || ''}
              >
                {licenseData?.licenseRoles?.map((role) => (
                  <option key={role[1]} value={role[1]}>
                    {role[0]}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div
          className={classNames(
            'pm-flex-col',
            tenantFormStyles.clearButtonSection
          )}
        >
          <div
            id={`clear_data_tenant_${tenantIndex}`}
            className={classNames(tenantFormStyles.clearButtonContainer, {
              [tenantFormStyles.visible]: showClearButton,
              [tenantFormStyles.hidden]: !showClearButton,
            })}
          >
            <button
              type="button"
              onClick={onClearEntitySearch}
              id={`tenant_clear_${tenantIndex}`}
              className="entity_search_clear mdc-button pm-text-color--blue1"
            >
              Clear existing tenant data
            </button>
            <input
              type="hidden"
              name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_id]`}
              className={`tenant_id_${tenantIndex}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TenantFormNameFields;
